@if (authenticatedUser(); as authenticatedUser) {
  <div class="toolbar bg-white flex items-center justify-between dark:bg-dark-700 dark:text-dark-100">
    <div class="items-end flex text-sm font-normal ml-4 transition-all">
      <div [tessTooltip]="templateForTooltip">Hi {{ authenticatedUser.data?.Contact?.FirstName }}</div>
      <ng-template #templateForTooltip>
        <strong>This is an example</strong>
        of a tooltip
      </ng-template>
      <lib-tess-icon icon="menu:waving-hand" size="var(--font-size-l)" />
    </div>

    <div class="flex items-center gap-6">
      <lib-tess-icon icon="my-icons:arrow-down-filled" size="var(--font-size-xxs)" class="arrow icon-tess-stroke-none" />
      <tess-toolbar-search />
      <div class="flex gap-x-1">
        <tess-toolbar-history />
        <tess-toolbar-shortcuts />
        <tess-toolbar-notifications />
      </div>

      <button
        type="button"
        mat-button
        aria-label="Language menu"
        class="language-button tess-button-gray-without-outline"
        disableRipple
        [matMenuTriggerFor]="languageMenu">
        <div class="flex items-center">
          <span [class]="['language-icon-wrap', currentLanguage]">
            <lib-tess-icon size="var(--font-size-l)" sprite="flagkit-5d650c45" [icon]="getLanguage(currentLanguage)" />
          </span>
          <span class="language-text uppercase">{{ currentLanguage }}</span>
          <lib-tess-icon icon="my-icons:arrow-down" size="var(--font-size-l)" color="neutral-600" />
        </div>
      </button>
      <mat-menu class="tess-menu-panel" #languageMenu="matMenu">
        @for (language of languages; track language) {
          <button type="button" mat-menu-item (click)="onLanguageChange(language)">
            <span [class]="['language-icon-wrap', language]">
              <lib-tess-icon size="var(--font-size-l)" sprite="flagkit-5d650c45" [icon]="getLanguage(language)" />
            </span>
            <span class="uppercase">{{ language }}</span>
          </button>
        }
      </mat-menu>

      <button
        type="button"
        mat-button
        aria-label="Agent menu"
        class="agent-menu-trigger mr-2 tess-button-gray-without-outline"
        disableRipple
        [matMenuTriggerFor]="menu">
        <div class="flex items-center">
          <tess-avatar
            [src]="authenticatedUser.data?.Contact?.PhotoURL"
            [initials]="authenticatedUser.data?.Contact?.Initials"
            [title]="authenticatedUser.data?.Contact?.FullName"
            size="xs" />
          <span class="contact-name">{{ authenticatedUser.data?.Contact?.FirstName }} {{ authenticatedUser.data?.Contact?.LastName }}</span>
          <lib-tess-icon icon="my-icons:arrow-down" size="var(--font-size-l)" color="neutral-600" />
        </div>
      </button>
      <mat-menu #menu="matMenu" class="tess-menu-panel">
        <button type="button" mat-menu-item (click)="navigateToMyProfile()" aria-label="My profile">
          <lib-tess-icon icon="menu:my-account" color="neutral-600" />
          <span>My profile</span>
        </button>
        <button mat-menu-item (click)="navigateToMyCompany()" aria-label="My company">
          <lib-tess-icon icon="menu:my-company" color="neutral-600" />
          <span>My company</span>
        </button>
        <mat-divider />
        <button type="button" mat-menu-item (click)="logOut()" aria-label="Log Out">
          <lib-tess-icon icon="menu:logout" color="neutral-600" />
          <span>Log out</span>
        </button>
      </mat-menu>
    </div>
  </div>
}
